<section class="filing-manager-toc-container">
  <mat-accordion class="filing-manager-toc-accordion" [multi]="false">
    <mat-expansion-panel *ngFor="let page of pages; let i = index; trackBy: trackByPage" [expanded]="currentPage === i"
      [ngClass]="{'highlighted':currentPage==i}" (opened)="onPanelOpened(i)">
      <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
        <mat-panel-title title="{{ i + 1 }}. {{ page.title }}">
          <span class="truncate">{{ i + 1 }}. {{ page.title }}</span>&nbsp;

          <span *ngIf="getErrorCount(page)>0" class="error-count" title="{{this.errorCountToolTip}}"><i
              class="fa-solid fa-triangle-exclamation"></i>{{getErrorCount(page)}}
          </span>

          <div class="fake" style="min-width: 10px;min-height: 3px;margin-inline: 5px 0;background: transparent"></div>

        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-panel-content>
        <app-elite-form-table-of-contents-item *ngIf="page.questions?.length" [questions]="page.questions"
          [parentIndex]="(i + 1) + '.'">
        </app-elite-form-table-of-contents-item>
      </mat-panel-content>
    </mat-expansion-panel>
  </mat-accordion>
</section>